import Cookies from 'react-cookies';
import COOKIES from '../../config/cookies/cookies';
import { NIBBLE_TIMER } from '../../config/text/text';
import {
  getIsChooseYourOptionsDeal,
  getIsChooseYourProductDeal,
  isBookingCalendarChooseDateDeal,
  isBookingCalendarOnRedemptionDeal,
} from '../../helpers/deals';
import { STATUS_ACTIVE } from '../../helpers/vipSubscribeHelper';

export const dealType = (deal) =>
  getIsChooseYourOptionsDeal(deal)
    ? 'Choose your options!'
    : isBookingCalendarChooseDateDeal(deal)
    ? 'View Availability!'
    : getIsChooseYourProductDeal(deal)
    ? 'Buy now!'
    : isBookingCalendarOnRedemptionDeal(deal)
    ? 'View Availability!'
    : null;

export const isNibbleEnabled = (
  deal,
  productId,
  userVipStatus,
  groupA = false,
) => {
  if (process.env.NEXT_PUBLIC_SITE !== 'wowcher') return false;

  const nibble = Cookies.load(COOKIES.nibble);
  if (nibble !== (groupA ? 'a' : 'b')) return false;

  return (
    deal?.products?.some((product) => {
      if (product.id !== productId) return false;

      return product?.nibbleWidgetTags?.some((tag) => {
        if (userVipStatus === STATUS_ACTIVE) {
          if (deal.vipPrice > 0) {
            return tag.vip === true;
          }

          return tag.vip !== true;
        }

        return tag.vip !== true;
      });
    }) || false
  );
};

export const isNibbleEnabledDealLevel = (
  deal,
  userVipStatus,
  groupA = false,
) => {
  if (process.env.NEXT_PUBLIC_SITE !== 'wowcher') return false;

  const nibble = Cookies.load(COOKIES.nibble);
  if (nibble !== (groupA ? 'a' : 'b')) return false;

  return (
    deal?.products?.some((product) => {
      return product?.nibbleWidgetTags?.some((tag) => {
        if (userVipStatus === STATUS_ACTIVE) {
          if (deal.vipPrice > 0) {
            return tag.vip === true;
          }

          return tag.vip !== true;
        }

        return tag.vip !== true;
      });
    }) || false
  );
};

export const NIBBLE_DWELL_TIME = 30_000;

export const nibbleDwellTimer = (delay = NIBBLE_DWELL_TIME) => {
  const localTimer = localStorage.getItem(NIBBLE_TIMER) === 'true' ? 0 : delay;

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, localTimer);
  });
};
